<script setup lang="ts"></script>
<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" fill="white" />
    <path
      d="M8.41542 8.02946V9.32542L13.5923 9.33001L7.95195 14.9229L8.87888 15.842L14.5192 10.2491L14.5146 15.3824L15.8308 15.3824V8.02946H8.41542Z"
      fill="currentColor"
    />
  </svg>
</template>
